import React, { useContext, useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import { toCurrency, toFormatedNumber } from '../utils/helpers';
import { Info } from '@mui/icons-material';
import Divider from '@mui/material/Divider';
import DownloadMenu from './DownloadMenu';
import InfoIcon from '@mui/icons-material/Info';
import InfoDialog from './InfoDialog';
import { log } from 'console';
import useApiRequest from '../services/apiRequest';

type Props = {
    q2: number;
    q3: number;
    threshold: number;
}


function OverpriceResultsTable({ q2, q3, threshold }: Props) {
    const { queryStringConverter} = useApiRequest();
    const { currentPage, setCurrentPage } = useContext(GlobalStateContext);
    const { pageSize, setPageSize } = useContext(GlobalStateContext);
    const { description, filters, searchType: search_type } = useContext(GlobalStateContext);
    const { currentUser } = useContext(GlobalStateContext);
    const { overpriceChartFilter } = useContext(GlobalStateContext);
    const [cFilter, setCFilter] = useState<any>(filters);
    const { data, error, loading } = useFetch(`${endpoints.ITEMS + `/${currentUser?.profile.username}`}${queryStringConverter({ page: currentPage, size: pageSize, sort: 'preco', search_type })}`, JSON.stringify({ description, ...cFilter }), "POST");
    const [openInfo, setOpenInfo] = useState(false);
    const [info, setInfo] = useState({});

    useEffect(() => {
        const price_range = [];
        for (const e of overpriceChartFilter) {
            price_range.push({ begin: e.begin, end: e.end });
        }
        setCFilter({ ...filters, ...{ ["price_range"]: price_range } });
    }, [overpriceChartFilter],);



    


    const renderCellAct = (params: GridRenderCellParams) => {
        return <div>
            <Tooltip title={<React.Fragment>
                <p>
                    Descrição <br />
                    {params.row.original_dsc}
                </p>
                <p className='mt-2'>
                    Descrição processada <br />
                    {params.row.palavras}
                </p>
                <p className='mt-2'>
                    Descrição automática <br />
                    {params.row.dsc_canonical}
                </p>
            </React.Fragment>}>
                <IconButton>
                    <Info />
                </IconButton>
            </Tooltip>
            {params.value}
        </div>;
    }
    const renderCellLic = (params: GridRenderCellParams) => {
        return <div>
            <Tooltip title={<React.Fragment>
                <p>
                    Id documento <br />
                    {params.row.id_licitacao}
                </p>
                <p className='mt-2'>
                    Município <br />
                    {params.row.municipio}
                </p>
                <p className='mt-2'>
                    Orgão <br />
                    {params.row.orgao}
                </p>
                <p className='mt-2'>
                    Modalidade <br />
                    {params.row.modalidade}
                </p>
                <p className='mt-2'>
                    Tipo de Licitação <br />
                    {params.row.tipo_licitacao}
                </p>
                <p className='mt-2'>
                    Número do processo <br />
                    {params.row.num_processo}
                </p>
                <p className='mt-2'>
                    Número da modalidade <br />
                    {params.row.num_modalidade}
                </p>
                <p className='mt-2'>
                    Fornecedor <br />
                    {params.row.cnpj_vencedor + ": " + params.row.nome_vencedor}
                </p>
            </React.Fragment>}>
                <IconButton>
                    <Info />
                </IconButton>
            </Tooltip>
            {params.value}
        </div>;
    }

    const renderCellPrice = (params: GridRenderCellParams) => {
        let color;
        if (params.row.preco <= (q3)) {
            color = "green";
        } else if (params.row.preco <= (threshold)) {
            color = "orange";
        } else if (params.row.preco > (100 * threshold)) {
            color = "gray";
        } else {
            color = "red";
        }

        return <div>
            <span>{params.value}</span>
            <Divider sx={{ bgcolor: color, height: 3 }} />
        </div>
    };

    const renderCellInfo = (params: GridRenderCellParams) => {
        return (
            <IconButton color="primary" aria-label="add to shopping cart" onClick={() => {
                setOpenInfo(true)
                setInfo(params.row)
            }}>
                <InfoIcon />
            </IconButton>
        )
    }

    const columns: GridColDef[] = [
        { field: 'original_dsc', headerName: 'Descrição Item', flex: 1, minWidth: 600, sortable: false },
        { field: 'dsc_unidade_medida', headerName: 'Unid. Medida', flex: 1, minWidth: 80, sortable: false },
        { field: 'flag_produto_servico', headerName: 'Srv / Prd', sortable: false },
        { field: 'preco_show', headerName: 'Preço unitário (R$)', flex: 1, minWidth: 150, align: 'left', headerAlign: 'left', renderCell: renderCellPrice, sortable: false },
        { field: 'qtde_item', headerName: 'Quantidade', align: 'left', headerAlign: 'left', sortable: false },
        { field: 'periodo', headerName: 'Período', minWidth: 110, align: 'left', headerAlign: 'left', sortable: false },
        { field: 'info', headerName: 'Info', width: 20, align: 'left', headerAlign: 'left', renderCell: renderCellInfo, sortable: false },

    ];



    const formatedData = () => data.data.map((d: any) => {

        return ({
            ...d,
            preco_show: toCurrency(d.preco),
            qtde_item: toFormatedNumber(d.qtde_item),
            periodo: d.periodo ? d.periodo.slice(0, 4) + "/" + d.periodo.slice(4, 6) : " "
        })


    })

    return (
        <>
            <InfoDialog open={openInfo} onClose={() => { setOpenInfo(false) }} info={info} />
            <div className='bg-white'>

                {loading || !data
                    ? <div className='h-result flex flex-col justify-center items-center'><CircularProgress /></div>
                    :
                    [
                        <>
                            <div className="h-result">
                                <DataGrid
                                    hideFooterSelectedRowCount
                                    paginationMode='server'
                                    pageSize={pageSize}
                                    rows={formatedData()}
                                    rowCount={data.total}
                                    page={currentPage}
                                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                    onPageChange={(newPage) => setCurrentPage(newPage)}
                                    columns={columns}
                                    getRowId={(e: any) => e.id_item}
                                />
                                <Box sx={{ display: 'flex', mt: '-3.5%', ml: 1 }}>
                                    <DownloadMenu />
                                </Box>
                            </div>
                        </>

                    ]
                }
            </div>
        </>


    );
}

export default OverpriceResultsTable;
